// extracted by mini-css-extract-plugin
module.exports = {"discountDisclaimer":"discountDisclaimer__33P2E","discountDisclaimer_saveOffers":"discountDisclaimer_saveOffers__CB3Cm","highlighted":"highlighted__ip_Yo"};